import { useAtomValue } from 'jotai';
import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';
import { templateQualityGateResolverAtom } from '../templateQualityGate.atoms';

const TemplateQualityGateModalImpl = dynamic(
  () =>
    import('./templateQualityGateModal.impl').then((mod) => ({
      default: mod.TemplateQualityGateModalImpl,
    })),
  { ssr: false, loading: () => null }
);

/**
 * Lightweight app-root gate for the template quality attestation. The dialog
 * implementation is loaded only after a create action first publishes a
 * resolver, and then stays mounted: the impl drives its own visibility from the
 * atom, so unmounting on close would tear the dialog out before it can play its
 * exit transition.
 */
export const TemplateQualityGateModal = () => {
  const resolver = useAtomValue(templateQualityGateResolverAtom);
  const [hasOpened, setHasOpened] = useState(false);

  useEffect(() => {
    if (resolver) {
      setHasOpened(true);
    }
  }, [resolver]);

  return hasOpened ? <TemplateQualityGateModalImpl /> : null;
};
